import { memo } from "react";
import cn from "classnames";

import { ProgressInPercentProps } from "./types";
import styles from "./styles.scss";

export const ProgressIndicator = memo(
  ({ progressInPercent = 0, isError = false }: ProgressInPercentProps) => (
    <div className={styles["progress-indicator"]}>
      <div
        className={cn(styles["success-line"], { [styles.error]: isError })}
        style={{ width: `${progressInPercent}%` }}
      />
    </div>
  )
);
